import {
  compose,
  withHandlers,
  withStateHandlers,
  defaultProps,
  pure,
  hoistStatics,
} from 'recompose';
import { tap, objOf } from 'ramda';

import { withRefs } from '../../../../utils/enchancers';
import TextAreaDefault from './messageTextArea';

const handlerHeightMessageTextArea = ({ getHeight, getRef }) => () => {
  if (getRef('messageTextArea')) {
    getHeight(getRef('messageTextArea').offsetHeight);
  }
};

const heightStateHandler = () => val => ({ height: val });
const toggleFocus = (state, { onFocusCallback = () => {} }) => compose(
  objOf('isFocus'),
  tap(onFocusCallback),
);


const onSetRefHandler = ({ setRef, childrenRef }) => (ref) => {
  setRef('messageTextArea', ref);
  childrenRef(ref);
};

const enhance = compose(
  withRefs(),
  defaultProps({
    onChangeHeight: () => {},
  }),
  withStateHandlers(() => ({ height: 0, isFocus: false, shortKeyActive: null }), {
    heightStateHandler,
    toggleFocusStateHandler: toggleFocus,
  }),
  withHandlers({
    handlerHeightMessageTextArea,
    onSetRef: onSetRefHandler,
  }),
  pure,
  hoistStatics,
);

export default enhance(TextAreaDefault);
